import React from 'react'
import FormJefes from '../view/RegistrarJefes'
import ListaJefes from '../view/ListarJefes'

const Jefes = () => {
  return (
    <div>
        <FormJefes/>
        <ListaJefes/>
    </div>
  )
}

export default Jefes